import { Routes } from "@angular/router";
import { GroupCompletedComponent } from "src/app/groups/group-completed/group-completed.component";
import { CartComponent } from "src/app/order/cart/cart.component";
import { CurrentorderComponent } from "src/app/order/currentorder/currentorder.component";
import { OrderComponent } from "src/app/order/order/order.component";
import { OrderaddressComponent } from "src/app/order/orderaddress/orderaddress.component";
import { OrderaddresseditComponent } from "src/app/order/orderaddressedit/orderaddressedit.component";
import { OrdercompletedComponent } from "src/app/order/ordercompleted/ordercompleted.component";
import { OrderdetailsComponent } from "src/app/order/orderdetails/orderdetails.component";
import { OrderinvoiceaddressComponent } from "src/app/order/orderinvoiceaddress/orderinvoiceaddress.component";
import { OrdersComponent } from "src/app/order/orders/orders.component";
import { PickupofficeComponent } from "src/app/order/pickupoffice/pickupoffice.component";

export const ODRER_ROUTES: Routes = [
   {
      path: 'order/cart', component: CartComponent
   },
   {
      path: 'order/details', component: OrderdetailsComponent
   },
   {
      path: 'order/adderess/select/:type', component: OrderaddressComponent
   },
   {
      path: 'order/adderess/edit/:type/:id', component: OrderaddresseditComponent
   },
   {
      path: 'order/adderess/edit/:type', component: OrderaddresseditComponent
   },
   {
      path: 'order/adderess/invoice/edit', component: OrderinvoiceaddressComponent
   },
   {
      path: 'orders', component: OrdersComponent
   },
   {
      path: 'order/precomplete', component: CurrentorderComponent
   },
   {
      path: 'order/pickup', component: PickupofficeComponent
   },
   {
      path: 'order/complete/:orderNumber', component: OrdercompletedComponent
   },
   {
      path: 'order/:id', component: OrderComponent
   },
   // GROUP
   {
      path: 'order/details/:group', component: OrderdetailsComponent
   },
   {
      path: 'order/precomplete/:group', component: CurrentorderComponent
   },
   {
      path: 'order/complete/group/:orderNumber', component: GroupCompletedComponent
   },

]